export default {
  header: 'Ups, ocorreu algo inesperado',
  text: 'Por favor, recarregue a página ou clique no botão “Voltar ao Início” abaixo.',
  button: 'Voltar ao Início',
};
